import AgenciesList from './AgenciesList'
import AgenciesSingle from './AgenciesSingle'
import AgenciesSinglePlacementsPdp from './AgenciesSinglePlacementsPdp'

export default {
  AgenciesList,
  AgenciesSingle,
  AgenciesSinglePlacementsPdp
}
